import { servicesApi } from '../services';
import { ContactResponse } from './types/contact-response.type';

export const contactApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({
    getContact: build.query<ContactResponse, void, any>({
      query: () => 'parametre/contact',
    }),
  }),
});

export const { useGetContactQuery } = contactApi;